import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    Navhidden: 1,
    NavigatorActive: 'home',
    Title: ''
  },
  getters: {
  },
  mutations: {
    // 接收参数并赋值给state中NavigatorActive
    NavHiddenChange(state, msg) {
      this.state.NavigatorActive = msg.to.name
      // 判断跳转页面更改Navhidden的值
      // if (msg.to.name == "home") {
      //   this.state.Navhidden = 0;
      // } else {
      //   this.state.Navhidden = 1
      // }
    },
    // 接受详情页面提交过来的title并赋值给Title
    ChildTitle(state, msg) {
      this.state.Title = msg.title
    }
  },
  actions: {
    // 接受全局钩子的传参并将其提交给mutations中的方法
    GiveMe(context, page) {
      context.commit('NavHiddenChange', page)
    }
  },
  modules: {
  }
})
